module.exports = __webpack_public_path__ + "img/photo_man.2d304414.png";